import Cell from './Cell'
import React from "react";
import { Avatar } from 'antd';

class Tile extends Cell {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.isEdit || false,
            x: props.x,
            y: props.y,
            w: props.w || 1,
            h: props.h || 1,
            color: props.color,
            icon: props.icon,
            title: props.title,
            url: props.url,
            iconLoaded: false, // 新增：图标加载状态
            iconError: false   // 新增：图标加载错误状态
        }
    }

    // 图标加载成功
    handleIconLoad = () => {
        this.setState({ iconLoaded: true, iconError: false });
    };

    // 图标加载失败
    handleIconError = () => {
        this.setState({ iconLoaded: true, iconError: true });
        // 可以设置一个默认图标
        // this.setState({ icon: "/favicon.ico" });
    };

    render() {
        let rect = this.getRect();
        
        return (
            <a
                draggable={this.state.isEdit}
                target="_blank"
                rel="noopener noreferrer"
                href={this.state.url}
            >
                <div
                    className="tile"
                    style={{
                        left: rect.left,
                        top: rect.top,
                        width: rect.width,
                        height: rect.height,
                        backgroundColor: this.state.color,
                    }}
                >
                    {/* 只在图标加载成功且没有错误时显示图标 */}
                    {this.state.iconLoaded && !this.state.iconError ? (
                        <Avatar 
                            shape="square" 
                            src={this.state.icon} 
                            className="tile-icon" 
                        />
                    ) : (
                        // 加载中或加载失败时显示占位符
                        <div className="tile-icon-placeholder">
                            {this.state.iconError ? '❌' : ''}
                        </div>
                    )}
                    
                    {/* 预加载图片但不显示，用于检测加载状态 */}
                    <img 
                        src={this.state.icon} 
                        style={{ display: 'none' }}
                        onLoad={this.handleIconLoad}
                        onError={this.handleIconError}
                        alt=""
                    />
                    
                    <span className="tile-title">{this.state.title}</span>
                </div>
            </a>
        )
    }
}

export default Tile;